import { getConfigValue } from '../utils/env';

// Log Levels
export const LOG_LEVELS = {
    INFO: 'INFO',
    WARNING: 'WARNING',
    ERROR: 'ERROR',
    DEBUG: 'DEBUG',
};

// Log Statuses
export const LOG_STATUSES = {
    SUCCESS: 'SUCCESS',
    FAILURE: 'FAILURE',
    CANCELLED: 'CANCELLED',
    PENDING: 'PENDING',
};

// Authentication Actions
export const AUTH_ACTIONS = {
    LOGIN: 'LOGIN',
    LOGIN_FAILURE: 'LOGIN_FAILURE',
    LOGOUT: 'LOGOUT',
    TOKEN_REFRESH_FAILURE: 'TOKEN_REFRESH_FAILURE',
    VIEW_PROFILE: 'VIEW_PROFILE',
};

// reCAPTCHA Actions
export const RECAPTCHA_ACTIONS = {
    RECAPTCHA_EXECUTE: 'RECAPTCHA_EXECUTE',
    RECAPTCHA_SUCCESS: 'RECAPTCHA_SUCCESS',
    RECAPTCHA_FAILURE: 'RECAPTCHA_FAILURE',
};

// IMID Verification Actions
export const IMID_VERIFICATION_ACTIONS = {
    REQUEST_IMID_TOKEN: 'REQUEST_IMID_TOKEN',
    IMID_VERIFICATION_START: 'IMID_VERIFICATION_START',
    IMID_VERIFICATION_REGISTERED: 'IMID_VERIFICATION_REGISTERED',
    IMID_VERIFICATION_COMPLETE: 'IMID_VERIFICATION_COMPLETE',
    IMID_VERIFICATION_FAILURE: 'IMID_VERIFICATION_FAILURE',
    IMID_VERIFY_PARTNER: 'IMID_VERIFY_PARTNER',
};

// Phone Verification Actions
export const PHONE_VERIFICATION_ACTIONS = {
    PHONE_VERIFICATION: 'PHONE_VERIFICATION',
    PHONE_VERIFICATION_FAILURE: 'PHONE_VERIFICATION_FAILURE',
    RESEND_PHONE_OTP: 'RESEND_PHONE_OTP',
    VERIFY_PHONE_OTP: 'VERIFY_PHONE_OTP',
};

// Email Verification Actions
export const EMAIL_VERIFICATION_ACTIONS = {
    EMAIL_VERIFICATION: 'EMAIL_VERIFICATION',
    EMAIL_VERIFICATION_FAILURE: 'EMAIL_VERIFICATION_FAILURE',
    RESEND_EMAIL_OTP: 'RESEND_EMAIL_OTP',
    VERIFY_EMAIL_OTP: 'VERIFY_EMAIL_OTP',
};

// Terms and Conditions Actions
export const TERMS_ACTIONS = {
    ACCEPT_TERMS: 'ACCEPT_TERMS',
    READ_TERMS: 'READ_TERMS',
    VERIFY_READ_TERMS: 'VERIFY_READ_TERMS',
    VIEW_TERMS: 'VIEW_TERMS',
};

// Sumsub Verification Actions
export const SUMSUB_VERIFICATION_ACTIONS = {
    SUMSUB_VERIFICATION_START: 'SUMSUB_VERIFICATION_START',
    SUMSUB_IMAGE_VERIFY: 'SUMSUB_IMAGE_VERIFY',
    SUMSUB_CHECK_COMPLETE: 'SUMSUB_CHECK_COMPLETE',
    SUMSUB_VERIFY_PARTNER: 'SUMSUB_VERIFY_PARTNER',
    SUMSUB_VERIFICATION_COMPLETE: 'SUMSUB_VERIFICATION_COMPLETE',
    SUMSUB_VERIFICATION_FAILURE: 'SUMSUB_VERIFICATION_FAILURE',
};

// Account Management Actions
export const ACCOUNT_ACTIONS = {
    UPDATE_ACCOUNT: 'UPDATE_ACCOUNT',
    VIEW_ACCOUNT: 'VIEW_ACCOUNT',
    ACCOUNT_COMPLETE: 'ACCOUNT_COMPLETE',
    ACCOUNT_UPDATE_FAILURE: 'ACCOUNT_UPDATE_FAILURE',
};

// Hash Verification Actions
export const HASH_VERIFICATION_ACTIONS = {
    VERIFY_HASH: 'VERIFY_HASH',
    HASH_VERIFICATION_SUCCESS: 'HASH_VERIFICATION_SUCCESS',
    HASH_VERIFICATION_FAILURE: 'HASH_VERIFICATION_FAILURE',
};

// File Operations Actions
export const FILE_ACTIONS = {
    UPLOAD_FILE: 'UPLOAD_FILE',
    UPLOAD_IMAGE: 'UPLOAD_IMAGE',
    VIEW_FILE: 'VIEW_FILE',
    DELETE_FILE: 'DELETE_FILE',
};

// Socket Actions
export const SOCKET_ACTIONS = {
    SOCKET_CONNECT: 'SOCKET_CONNECT',
    SOCKET_DISCONNECT: 'SOCKET_DISCONNECT',
    SOCKET_CONNECT_ERROR: 'SOCKET_CONNECT_ERROR',
};

// API Error Actions
export const API_ERROR_ACTIONS = {
    API_ERROR: 'API_ERROR',
    NETWORK_ERROR: 'NETWORK_ERROR',
};

// All Actions (for validation)
export const ALL_ACTIONS = {
    ...AUTH_ACTIONS,
    ...RECAPTCHA_ACTIONS,
    ...IMID_VERIFICATION_ACTIONS,
    ...PHONE_VERIFICATION_ACTIONS,
    ...EMAIL_VERIFICATION_ACTIONS,
    ...TERMS_ACTIONS,
    ...SUMSUB_VERIFICATION_ACTIONS,
    ...ACCOUNT_ACTIONS,
    ...HASH_VERIFICATION_ACTIONS,
    ...FILE_ACTIONS,
    ...SOCKET_ACTIONS,
    ...API_ERROR_ACTIONS,
};

// LocalStorage Keys
export const STORAGE_KEYS = {
    LOG_QUEUE: 'logQueue',
    LOG_METADATA: 'logMetadata',
};

/**
 * Returns logging config from env/runtime config (getConfigValue).
 */
export function getDefaultConfig() {
    return {
        ENABLED: getConfigValue('REACT_APP_LOGGING_ENABLED') === 'true',

        QUEUE_MAX_SIZE: Number(
            getConfigValue('REACT_APP_LOG_QUEUE_MAX_SIZE', '100')
        ),

        RETRY_INTERVAL: Number(
            getConfigValue('REACT_APP_LOG_RETRY_INTERVAL', '5000')
        ),

        MAX_RETRIES: Number(getConfigValue('REACT_APP_LOG_MAX_RETRIES', '5')),

        RETRY_BACKOFF_MULTIPLIER: Number(
            getConfigValue('REACT_APP_LOG_RETRY_BACKOFF_MULTIPLIER', '2')
        ),

        ENTRY_TTL_MS: Number(
            getConfigValue('REACT_APP_LOG_ENTRY_TTL_MS', '86400000')
        ),

        LOG_ENDPOINT: getConfigValue('REACT_APP_LOG_ENDPOINT', '/logging'),
    };
}

export const DEFAULT_CONFIG = getDefaultConfig();
